import { EmpeApiClient } from '@/api-clients/empe-client';
import { Review } from '@/models/review';

export const getReviews = async (): Promise<Review[]> => {
    return await EmpeApiClient.get<Review[]>('/google/reviews');
};
